import { motion } from "framer-motion";
import { useState } from "react";
import { useT } from "../lang";

const T = {
  pt: {
    label: "05 · substack",
    cta: "assine minha newsletter grátis",
    placeholder: "seu@email.com",
    submit: "assinar →",
    err: "precisa de um e-mail válido.",
    sent: "✷ abrindo o substack pra confirmar…",
    idle: "você será redirecionada pro substack pra confirmar.",
  },
  en: {
    label: "05 · substack",
    cta: "subscribe to my free newsletter",
    placeholder: "your@email.com",
    submit: "subscribe →",
    err: "we need a valid email.",
    sent: "✷ opening substack to confirm…",
    idle: "you'll be redirected to substack to confirm.",
  },
};

export default function Substack() {
  const t = useT(T);
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");

  const submit = (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      setStatus("error");
      return;
    }
    setStatus("sent");
    const url = `https://substack.com/@gabrielasfs?email=${encodeURIComponent(
      email
    )}`;
    window.open(url, "_blank", "noreferrer");
    setEmail("");
    setTimeout(() => setStatus("idle"), 3200);
  };

  return (
    <section
      id="substack"
      data-testid="substack-section"
      className="relative py-24 md:py-32"
    >
      <div className="container-wide">
        <div className="flex items-center gap-3 mb-10">
          <span className="label">{t.label}</span>
          <span className="text-2xl">☻</span>
        </div>

        <motion.form
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="max-w-[720px] border border-[color:var(--ink)] bg-cloud"
          data-testid="substack-card"
          onSubmit={submit}
        >
          <div className="p-6 md:p-8">
            <div className="label mb-6">{t.cta}</div>

            <div className="flex flex-col sm:flex-row gap-2">
              <input
                type="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (status !== "idle") setStatus("idle");
                }}
                placeholder={t.placeholder}
                required
                aria-label="email"
                data-testid="substack-email-input"
                className="flex-1 border border-[color:var(--ink)] bg-cloud px-4 py-3 font-body text-base placeholder-ink/40 focus:outline-none focus:bg-off"
              />
              <button
                type="submit"
                data-testid="substack-submit"
                className="border border-ink bg-ink text-off px-6 py-3 font-body text-sm font-semibold hover:bg-brick hover:border-brick transition-colors"
              >
                {t.submit}
              </button>
            </div>

            <div
              className="mt-3 font-narrow text-xs min-h-[16px]"
              data-testid="substack-status"
            >
              {status === "error" && <span className="text-brick">{t.err}</span>}
              {status === "sent" && <span className="text-ink/70">{t.sent}</span>}
              {status === "idle" && <span className="text-ink/50">{t.idle}</span>}
            </div>
          </div>
        </motion.form>
      </div>
    </section>
  );
}
